import(/* webpackMode: "eager" */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/app/not-found.tsx");
